const reais = valor => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

export function avaliarLimitesGarantia (valor, regra) {
  const total = Number(Number(valor).toFixed(2))
  if (regra?.gseValorGarantiaMinimo != null && total < regra.gseValorGarantiaMinimo)
    return { erro: `O valor total da garantia (${reais(total)}) é inferior ao mínimo de ${reais(regra.gseValorGarantiaMinimo)}.` }
  if (regra?.gseValorGarantiaMaximo != null && total > regra.gseValorGarantiaMaximo)
    return { aviso: `O valor total da garantia supera ${reais(regra.gseValorGarantiaMaximo)}. O pedido deverá passar por análise manual, sem consulta automática.` }
  return {}
}
